<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.83341 9.08333C7.94175 8.59167 7.33341 8.08333 7.33341 7.29167C7.33341 6.38333 8.17508 5.75 9.58341 5.75C10.7667 5.75 11.3584 6.2 11.5751 6.91667C11.6751 7.25 11.9501 7.5 12.3001 7.5H12.5501C13.1001 7.5 13.4917 6.95833 13.3001 6.44167C12.9501 5.45833 12.1334 4.64167 10.8334 4.325V3.75C10.8334 3.05833 10.2751 2.5 9.58341 2.5C8.89175 2.5 8.33341 3.05833 8.33341 3.75V4.3C6.71675 4.65 5.41675 5.7 5.41675 7.30833C5.41675 9.23333 7.00841 10.1917 9.33341 10.75C11.4167 11.25 11.8334 11.9833 11.8334 12.7583C11.8334 13.3333 11.4251 14.25 9.58341 14.25C8.20841 14.25 7.50008 13.7583 7.22508 13.0583C7.10008 12.7333 6.81675 12.5 6.47508 12.5H6.24175C5.68341 12.5 5.29175 13.0667 5.50008 13.5833C5.97508 14.7417 7.08341 15.425 8.33341 15.6917V16.25C8.33341 16.9417 8.89175 17.5 9.58341 17.5C10.2751 17.5 10.8334 16.9417 10.8334 16.25V15.7083C12.4584 15.4 13.7501 14.4583 13.7501 12.75C13.7501 10.3833 11.7251 9.575 9.83341 9.08333Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
